<div
  [innerHTML]="svgContent"
  class="svg-icon"></div>
